import React, { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";
import "boxicons/css/boxicons.min.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadingFalse, loadingTrue } from "../Reducer/loaderSlice";
import Handler from "../Helpers/Handler";
import UserIcon from '../Assets/images/user.png'
const Header = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(s => s.customer.customer);
    const [lowStockCount, setLowStockCount] = useState(0);

    const loadLowStockCount = async () => {
        if (!user?.outlet_id) return;

        dispatch(loadingTrue());
        try {
            const res = await Handler({
                method: "get",
                url: `/products/low_stock_alert.php?page=1&limit=1&outlet_id=${user.outlet_id}`
            });

            if (res?.success) {
                // 🔥 backend-la total_low_stock iruku
                setLowStockCount(res.data.total_low_stock || 0);
            }
        } catch (e) {
            console.log("Low stock fetch failed");
        }
        dispatch(loadingFalse());
    };

    useEffect(() => {
        loadLowStockCount();
    }, [user?.outlet_id]);


    return (
        <React.Fragment>
            <header className="app-header">
                <div className="header-left">
                    <Button onClick={() => navigate('/products-add')} className="add-btn">Add New</Button>
                    <Button onClick={() => navigate('/pos')} className="pos-btn">POS</Button>
                </div>
                <div className="header-right">
                    <Button onClick={() => navigate('/history')} className="store-btn">History</Button>

                    <div className="notification-icon" onClick={() => navigate("/lowstock")} style={{ position: "relative", cursor: "pointer" }}><i className="bx fs-3 bx-bell"></i>
                        {lowStockCount > 0 && (
                            <span
                                style={{ position: "absolute", top: "-5px", right: "-8px", background: "#dc3545", color: "#fff", borderRadius: "50%", fontSize: "11px", padding: "2px 6px", lineHeight: "1" }} >
                                {lowStockCount}
                            </span>
                        )}
                    </div>
                    <Link to='/profile'><img className="user-avatar" src={UserIcon} alt="user" /></Link>
                </div>
            </header>
        </React.Fragment>
    )

};

export default Header
